import { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ContextStatus } from '@leedpulse-monorepo/enums';
import PageScaffold from '../../components/PageScaffold';
import {
  SUBSCRIPTIONS_PAGE_PATH,
  SUBSCRIPTIONS_PAGE_TITLE,
} from './SubscriptionsPage';
import MultiChat from '../../components/subscription_chats_page/MultiChat';
import SubscriptionChatsContext from '../../contexts/data/SubscriptionChatsContext';
import { Spin } from 'antd';
import { useNavigate } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface SubscriptionChatsPageProps {}

export const SUBSCRIPTIONS_CHATS_PAGE_PATH = '/chats';
export const SUBSCRIPTIONS_CHATS_PAGE_TITLE = 'Conversations';

const SubscriptionChatsPage: React.FC<SubscriptionChatsPageProps> = () => {
  const navigate = useNavigate();
  const subscriptionChatsContext = useContext(SubscriptionChatsContext);

  const { subscriptionId } = useParams<{ subscriptionId: string }>();

  useEffect(() => {
    if (subscriptionChatsContext.initializationStatus === ContextStatus.IDLE && subscriptionId) {
      subscriptionChatsContext.initWithSubscriptionId(subscriptionId);
    }
    return () => {
      subscriptionChatsContext.reset();
    };
  }, []);

  if(!subscriptionId) {
    navigate(SUBSCRIPTIONS_PAGE_PATH);
    return;
  }

  return (
    <PageScaffold
      title={SUBSCRIPTIONS_CHATS_PAGE_TITLE}
      subtitle={"Consultez l'ensemble des conversations de l'abonnement"}
      breadcrumbItems={[
        {
          target: SUBSCRIPTIONS_PAGE_PATH,
          title: SUBSCRIPTIONS_PAGE_TITLE,
        },
        {
          title: SUBSCRIPTIONS_CHATS_PAGE_TITLE,
        },
      ]}
    >
      {subscriptionChatsContext.initializationStatus ===
      ContextStatus.SUCCESS ? (
        <MultiChat />
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'calc(100% - 112px)',
          }}
        >
          <Spin />
        </div>
      )}
    </PageScaffold>
  );
};

export default SubscriptionChatsPage;
